import { ReactNode } from 'react';

interface StepProps {
  number: number;
  children: ReactNode;
}

export default function Step({ number, children }: StepProps) {
  return (
    <div className="flex gap-3.5 mb-4">
      <div className="w-[30px] h-[30px] rounded-full bg-gradient-to-br from-oak-green to-[#059669] text-white flex items-center justify-center font-bold text-sm flex-shrink-0 shadow-[0_2px_4px_rgba(16,185,129,0.3)]">
        {number}
      </div>
      <div className="flex-1 pt-1 text-content-primary text-[15px] leading-[1.7]">{children}</div>
    </div>
  );
}
